import Nullstack from 'nullstack';
export default function IconPodium({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-podium",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v-2a3 3 0 0 1 3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M8 12l1 9"
  }), "   ", Nullstack.element("path", {
    d: "M16 12l-1 9"
  }), "   ", Nullstack.element("path", {
    d: "M7 21h10"
  }), " ");
}